import * as React from 'react';

import {Link} from 'shells/link/link';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function BodyTeam() {
    return (
        <OnboardingBody title='We’re always here to help!'>
            <div>
                <p>Click the question mark to chat with our award-winning customer support team.</p>
                <p>
                    And when you email us at{' '}
                    <Link href='mailto:support@nutshell.com'>support@nutshell.com</Link>, you’ll
                    hear back from a friendly person. 😊
                </p>
            </div>
        </OnboardingBody>
    );
}
